import Companies from './company-list'
import NoSitesListedYet from './no-list-yet'
import { useBreakdownInfoQuery } from '../../../store/api'

export default function CompanyList() {
  const { data, isLoading } = useBreakdownInfoQuery()

  return (
    <div>
      {data?.length === 0 ? <NoSitesListedYet /> : <Companies data={data} />}
      {/* <NoSitesFound /> */}
    </div>
  )
}
